import React from 'react';
import { AAMBeaconIconButton, AAMBeaconPopover } from '../Beacon';
import { ReactComponent as Icon } from 'assets/icons/beacon/Information.svg';
import './FormLabelWithPopover.scss';

const FormLabelWithPopover = ({ title, content, popoverTitle, placement = 'top', className = "" }) => (
  <label slot='label'className='beacon-on-dark bene-name'>
      {title}
    <AAMBeaconIconButton id={`popover-trigger-${className}`} variant='tertiary'>
      <Icon slot="icon" />
    </AAMBeaconIconButton>
    <AAMBeaconPopover
        opens-by={`#popover-trigger-${className}`}
        placement={placement}
    >
        <h2 className={'bene-popover-title b-font-weight-bold'}>{popoverTitle}</h2>
        <div>{content}</div>
      </AAMBeaconPopover>
  </label>
);

export default FormLabelWithPopover;
